var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/white_circular_arrow.06870297.png","uri@2x": __webpack_public_path__ + "static/media/white_circular_arrow.58b85d76.png","uri@3x": __webpack_public_path__ + "static/media/white_circular_arrow.20fd80e7.png",
    width: 10,
    height: 10
});